import { InjectionToken, Provider } from '@angular/core';

import { Environment } from '@fatigue/environments/env';
import { environment } from '@fatigue/environments/environment';

export const ENVIRONMENT = new InjectionToken<Environment>('ENVIRONMENT');

export const environmentProvider: Provider = {
  provide: ENVIRONMENT,
  useValue: environment,
};
